import React, { useEffect, useRef } from "react";
import AssistantPng from "../../../assets/campaignBuilder/ai-chat/assistant.png";
import { useTranslation } from "react-i18next";

interface AssistantProps {
  message: string;
}

export const Assistant: React.FC<AssistantProps> = ({ message })=>{
   const { t, i18n } = useTranslation(["aiChart"]);

   const paraRef = useRef(null);

  const arryTitle = [
    "Title of Property:",
    "Description of Property:",
    "Message:",
    "שם הנכס:",
    "תיאור הנכס:",
    "טקסט:"
  ];
  const getStyledMessage = () => {
    if (!message) return null;

    let modifiedText = message;

    // Replace each title with a styled version
    arryTitle?.forEach(title => {
      const regex = new RegExp(`(${title})`, "g");
      modifiedText = modifiedText?.replace(
        regex,
        `<span style="font-weight: 600;">$1</span>`
      );
    });

    return <span dangerouslySetInnerHTML={{ __html: modifiedText }} />;
  };

  
  return (
    <div className="assistent">
      <div className="assistent_first_child">
        <div className="img_box">
          <img src={AssistantPng} alt="" />
        </div>
        <h3>{t("ai_assistant")}</h3>
      </div>

      <div className="assistent_second_child">
        <p  ref={paraRef}>{getStyledMessage()}</p>
      </div>

    </div>
  );
};

